
export const encodeURL = (url: string) => {
    const  encodedUrl = encodeURIComponent(url);
    return btoa(encodedUrl).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export const decodeURL = (encodedUrl: string) => {
    let base64 = encodedUrl.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
        base64 += "=";
    }
    const decodedUrl = atob(base64);
    return decodeURIComponent(decodedUrl);
}
